export const roiPartLegendForTooltip = `
  (Green) - Meets the requirements
  (Red) - Does not meet the requirements
  (Yellow) - Warning
`;
